import React from 'react';
import Select from '@mos-front-components/public/es/components/MosSelect/MosSelect';
import { createStructuredSelector } from 'reselect';
import { connect } from 'dva';

import { isZelArea } from '../../../../selectors/addressUnmodeled';

interface Props {
  isVisible: boolean;
}

function AddressZelenogradCity(props: Props): JSX.Element | null {
  if (!props.isVisible) return null;
  return (
    <div className="PguFormGrid__row">
      <Select
        className="PguFormGrid__field PguFormGrid_col ym-hide-content"
        placeholder={'Город'}
        value="Зеленоград"
        name={'city'}
        suggestions={[]}
        onChange={() => {}}
        disabled
        dropListView
      />
    </div>
  );
}
const mapStateToProps = createStructuredSelector({
  isVisible: isZelArea,
});

export default connect(mapStateToProps)(AddressZelenogradCity);
